import React from 'react'
import { Link } from 'react-router-dom'

const Seekers = () => {
  return (
    <div className='block'>
      <div className="topContainer">
        <div className='headingTop'>
        <p>OVER 130K REMOTE & LOCAL STARTUP JOBS</p>
        </div>
        <div className="headingMain">
          <h2>Find what's next <span style={{color: "red"}}>:</span> </h2>
        </div>
      </div>

      <div>
        <h2 style={{marginTop:"64px", marginBottom:"32px"}}>Featured Companies hiring now!</h2>
      </div>
      <div>
        <div className="jobContainer">
          <div className="card">
            <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://photos.wellfound.com/startups/i/37683-b109108b8062148bcf51903a54d5eb92-medium_jpg.jpg?buster=1585094302" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
                Amazon
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Earth's most customer-centric company</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://photos.wellfound.com/startups/i/32920-2787318454cce05a36eaba5be4d0e660-medium_jpg.jpg?buster=1589657556" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
                HubSpot
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Solutions to help you grow, by increasing leads, accelerating sales, and organizing your contacts</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://photos.wellfound.com/startups/i/271485-0323baf5a3b7d6dc76ab970febe7bcbf-medium_jpg.jpg?buster=1589507555" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
                DoorDash
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Your favorite restaurants, delivered</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://photos.wellfound.com/startups/i/33986-687620e87450ee4654c88a0417d81358-medium_jpg.jpg?buster=1589601889" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
                Netflix
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">World's leading streaming entertainment service</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 style={{marginTop:"64px", marginBottom:"32px"}}>Trending StartUp Jobs</h2>
      </div>
      <div>
        <div className="jobContainer">
        <div className="card">
            <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/32624-23c4d24c64daa52327832cc162efc8a5-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              Decision Engine Platform
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Software Engineer III (Backend), Decision Engine Platform</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/25581-03f813526d5ca2253fd49bfeffa94a43-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              B2B Solutions
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Senior Business Development Representative</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/25999-fc9bbc64435d1b62a3b3e89fc125cc1d-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              BinnaceLabs
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Social Media Manager and Strategist for a BinnaceLabs S4 company</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/3231-185925c98c2baa1415447a6b99f74774-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              Product Owner
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">World's leading streaming entertainment service</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 style={{marginTop:"64px", marginBottom:"32px"}}>Engineering Jobs</h2>
      </div>
      <div>
        <div className="jobContainer">
          <div className="card">
            <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/157634-04b5245e05cdf722c57b40c0c6297c83-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              Topaz Labs
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Software Engineer (Product), Senior Developer (Web)</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/32624-23c4d24c64daa52327832cc162efc8a5-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              Prosper Marketplace
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Staff Software Engineer (Mobile Applications)</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/72299-a8f6edb3d8022c8f0fdb1cf63d6a4f8f-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              MovingWorlds
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Lead Engineer at a Scaling Social Enterprise</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
          <div className="card">
          <div className='d-flex p-2 card-header'>
              <div className="jobImg">
              <img alt="Amazon" className="mr-4 h-12 w-12 rounded-md" src="https://wellfound.com/cdn-cgi/image/width=92,height=92,fit=scale-down,gravity=0.5x0.5,quality=90,format=auto/https://photos.wellfound.com/startups/i/550668-7c572b578acc8450b45b70320ea7a522-medium_jpg.jpg" style={{height:"30px"}}/>
              </div>
              <div className="d-flex p-2">
              SetWorks
              </div>
            </div>
            <div className="card-body">
              <p className="card-text">Senior .NET Blazor Developer (Full Stack) (Remote, USA Only)</p>
              <a href="/" className="btn btn-primary jobBtnLink">Apply Now</a>
            </div>
          </div>
        </div>
      </div>
      <div className='my-5 d-flex JobJoin'>
        <div className='block d-flex companyfoot2' style={{width: "100%"}}>
          <h1>Not a part of JOBFOUND? Join now</h1>  
        </div>
        <Link to="/signup"><button type="button" className="btn btn-outline-dark login mx-1 my-2" style={{width:"25%", minWidth:"115px"}}>Sign Up</button></Link>
      </div>

    </div>
  )
}

export default Seekers